import * as React from "react";
const SvgExpandIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m296-345-56-56 240-240 240 240-56 56-184-184-184 184Z" }));
export default SvgExpandIcon;
